// Chilean RUT validation (modulo 11) — mirrors backend services/rut.py

export function normalizeRut(rut) {
  return (rut || "").replace(/[^0-9kK]/g, "").toUpperCase();
}

export function computeDv(body) {
  if (!body || !/^\d+$/.test(body)) return "";
  let sum = 0, mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const rest = 11 - (sum % 11);
  if (rest === 11) return "0";
  if (rest === 10) return "K";
  return String(rest);
}

export function isValidRut(rut) {
  const clean = normalizeRut(rut);
  if (clean.length < 8 || clean.length > 9) return false;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  return computeDv(body) === dv;
}

export function formatRut(rut) {
  const clean = normalizeRut(rut);
  if (clean.length < 2) return rut;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  if (!/^\d+$/.test(body)) return rut;
  const rev = body.split("").reverse().join("");
  const chunks = [];
  for (let i = 0; i < rev.length; i += 3) chunks.push(rev.slice(i, i + 3).split("").reverse().join(""));
  return chunks.reverse().join(".") + "-" + dv;
}
